import { CSVLink } from "react-csv";
import { Download } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const CsvDownloadButton = ({ data, headers, filename }) => {
  const { t } = useTranslation(["translation", "statistics"]);

  return (
    <CSVLink
      className="btn btn-sm btn-outline-success"
      data={data}
      headers={headers}
      filename={filename}
      onClick={() => {
        toast.success(t("exports.Downloaded", { ns: "statistics" }));
      }}
    >
      <Download size={14} className="me-1" />
      {t("exports.Download", { ns: "statistics" })}
    </CSVLink>
  );
};

export default CsvDownloadButton;
